import { render, staticRenderFns } from "./ComprovanteView.vue?vue&type=template&id=3876b392&"
import script from "./ComprovanteView.vue?vue&type=script&lang=js&"
export * from "./ComprovanteView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports